<template>
<div>

  <div v-if="silos.length" class="sites-or-pages-container silos-container mt-6">
    <silo-card
      v-for="(silo, idx) in silos"
      :key="idx"
      :silo="silo"
      :isProjectLevelView="true"
      :refreshData="() => fetchSilos()"
    />
  </div>

  <div
    v-else-if="showEmptyState"
    class="silo-container-empty silo-container-empty--stacked mb-5 mt-6"
  >
    <div class="silo-structure-empty-container">
      <img src="/static/silo-structure.svg" class="silo-structure" alt="" />
    </div>
    <div class="silo-text-empty-container">
      <div class="step-title" style="text-align: left; width: 100%;">You haven’t created your content silo yet</div>
      <div class="title-text" style="text-align: left;">
        Please add some keywords from Keyword Insight or Keyword Wizard tabs
        to create content silo for this page. You will be redirected to
        Keyword Insight tab by default.
      </div>
      <div class="gap1">
        <v-btn
          @click="gotoKeywordInsight"
          rounded
          color="profileAnchorColor"
          class="text-none whiteColor--text font16 padding8 height38 button-with-icon"
        >
          <i class="material-icons mr-1">auto_awesome</i>
          <span>Start Keyword Research</span>
        </v-btn>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import SiloCard from '@/components/Campaigns/silo/SiloCard.vue';

export default {
  components: {
    SiloCard
  },
  data () {
    return {
      silos: [],
      silosFetchDone: false,
    }
  },
  computed: {
    siteId () {
      return this.$route.params.siteId;
    },
    showEmptyState () {
      return this.silosFetchDone && !this.silos.length;
    },
  },
  watch: {
    showEmptyState (visible) {
      this.$emit('empty-state-visible', visible);
    },
  },
  methods: {
    defaultCampaignPageId () {
      const pages = this.$store.getters.siteById(Number.parseInt(this.siteId, 10))?.pages || [];
      const pinned = pages.find((p) => p.isPinned);
      if (pinned) {
        return pinned.id;
      }
      return pages[0]?.id;
    },
    gotoKeywordInsight () {
      const campaignId = this.defaultCampaignPageId();
      if (campaignId) {
        this.$router.push(
          `/sites/${this.siteId}/campaign/${campaignId}/keyword-insight`,
        );
        return;
      }
      this.$router.push({
        path: `/sites/${this.siteId}/pages`,
        query: { tab: 'keyword-research' },
      });
    },
    fetchSilos() {
      this.$store.commit('showLoading');
      this.$store
        .dispatch('getSilos', { siteId: this.$route.params.siteId, paginate: 0 })
        .then((response) => {
          this.silos = response.data.data;
        })
        .finally(() => {
          this.silosFetchDone = true;
          this.$store.commit('hideLoading');
        });
    },
  },
  mounted () {
    this.fetchSilos()
  }
}
</script>

<style lang="scss" scoped>
@import '@/components/Campaigns/silo/silo.scss';
</style>
